import { useMemo } from "react";
import { useGetList } from "ra-core";

import type { PublicHoliday } from "../types";

/**
 * Loads public holidays once and shares the cached result between all
 * consumers (same react-query key, never refetched), returning their
 * `YYYY-MM-DD` dates.
 */
export const usePublicHolidays = () => {
  const { data, isPending } = useGetList<PublicHoliday>(
    "public_holidays",
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "date", order: "ASC" },
    },
    { staleTime: Infinity, refetchOnWindowFocus: false, refetchOnMount: false },
  );
  const holidays = useMemo(
    () => new Set((data ?? []).map((holiday) => holiday.date.slice(0, 10))),
    [data],
  );
  return { holidays, isPending };
};
